import { MemberModel } from './member-model'

export interface rbMultiSelectItem {
  id: string
  label: string
}

export type FrontendItems = {
  scopes: rbMultiSelectItem[]
  roles: rbMultiSelectItem[]
}

export type ProductOption = {
  name: string
  backendscopes: string[]
  roles: string[]
  frontendItems: FrontendItems
}

export interface IGroupModel {
  group: string
  productOptions: ProductOption[]
  members: MemberModel[]
}

export class GroupModel implements IGroupModel {
  group: string
  productOptions: ProductOption[]
  members: MemberModel[]

  constructor(data: Partial<GroupModel>) {
    // Assign properties from the data object
    this.group = data.group || ''
    this.productOptions = data.productOptions || []
    this.members = data.members?.map((member) => new MemberModel(member)) || []

    // Process backendscopes to backendScopesFrontEnd
    for (const productOption of this.productOptions) {
      productOption.frontendItems = {
        scopes: [],
        roles: [],
      }
      if (productOption.backendscopes) {
        productOption.frontendItems.scopes = productOption.backendscopes.map(
          (bs: string) => ({
            id: bs,
            label: bs,
          }),
        )
      } else {
        productOption.frontendItems.scopes = []
      }
      if (productOption.roles) {
        productOption.frontendItems.roles = productOption.roles.map(
          (bs: string) => ({
            id: bs,
            label: bs,
          }),
        )
      } else {
        productOption.frontendItems.roles = []
      }
    }
  }
}
